import { PT_HUB_ALTERNATES } from '../../../../../components/market/PtTopicPage'

// KL guide in Bahasa Melayu: jurulatih peribadi. Part of the PT hub hreflang
// set as the ms-MY member (see PT_HUB_ALTERNATES).
const content = {
    lang: 'ms',
    slug: 'jurulatih-peribadi-kl',
    title: (c) => `Jurulatih Peribadi di KL | Dari ${c.money(c.lowest, 0)} Satu Sesi`,
    description: (c) =>
        `Jurulatih peribadi bertauliah di Kuala Lumpur - di gim kondo, di rumah atau di taman. Pakej dari ${c.money(c.lowest, 0)} satu sesi. Jurulatih wanita tersedia.`,
    eyebrow: 'KL · Jurulatih peribadi',
    h1: 'Jurulatih Peribadi di Kuala Lumpur',
    lead: 'Latihan satu-ke-satu bersama jurulatih bertauliah, di tempat yang paling mudah untuk anda: gim kondo, rumah atau taman berhampiran. Beritahu kami matlamat anda dan kami padankan dengan jurulatih yang sesuai.',
    datePublished: '2026-10-03',
    image: 'personal-trainer/personal-trainer.jpg',
    imageAlt: 'Jurulatih peribadi membimbing klien',
    summary: {
        title: 'Harga pakej (Signature)',
        items: [],
    },
    sections: [
        {
            title: 'Pakej dan harga',
            table: {
                columns: [
                    { key: 'pakej', label: 'Pakej' },
                    { key: 'signature', label: 'Signature (2+ tahun)' },
                    { key: 'elite', label: 'Elite (5+ tahun)' },
                ],
                rows: (c) => [14, 24, 30, 50].map((n) => ({
                    pakej: `${n} sesi`,
                    signature: `${c.money(c.pt('Signature', n), 0)} / sesi`,
                    elite: `${c.money(c.pt('Elite', n), 0)} / sesi`,
                })),
            },
            paragraphs: [
                (c) => `Sesi pada waktu puncak (sebelum 9 pagi, selepas 4 petang dan hujung minggu) ditambah ${c.money(c.mods.peak, 0)} satu sesi. Permintaan jurulatih wanita ditambah ${c.money(c.mods.female, 0)} satu sesi. Tempahan dalam talian menjimatkan ${c.money(c.mods.online, 0)} setiap sesi.`,
            ],
        },
        {
            title: 'Di mana sesi dijalankan',
            cards: [
                { title: 'Gim kondo', body: 'Kebanyakan kondo di KL ada gim. Semak peraturan pengurusan tentang jurulatih luar.' },
                { title: 'Di rumah', body: 'Jurulatih membawa peralatan mudah alih - band, dumbbell dan tikar.' },
                { title: 'Di taman', body: 'Awal pagi di Bukit Kiara, Taman Tasik Titiwangsa atau Taman Botani Perdana.' },
                { title: 'Dalam talian', body: 'Untuk minggu yang sibuk atau ketika ke luar kawasan.' },
            ],
        },
        {
            title: 'Matlamat yang biasa',
            items: [
                'Menurunkan berat badan dengan cara yang berkekalan.',
                'Membina kekuatan dan otot.',
                'Kembali cergas selepas bersalin dan berpantang.',
                'Latihan untuk warga emas - keseimbangan dan pergerakan.',
                'Sesi muslimah bersama jurulatih wanita.',
            ],
        },
    ],
    faqs: [
        {
            question: 'Berapa harga jurulatih peribadi di KL?',
            answer: (c) => `Dengan StringsSG, dari ${c.money(c.lowest, 0)} hingga ${c.money(c.pt('Elite', 14), 0)} satu sesi, bergantung pada pakej dan tahap jurulatih.`,
        },
        {
            question: 'Bolehkah saya minta jurulatih wanita?',
            answer: 'Boleh. Pilih jurulatih wanita semasa membuat permintaan. Sesi muslimah juga boleh diatur.',
        },
        {
            question: 'Adakah jurulatih anda bertauliah?',
            answer: 'Ya. Kami menyemak sijil setiap jurulatih sebelum mereka menyertai kami.',
        },
    ],
    alternates: PT_HUB_ALTERNATES,
    relatedLinks: [
        { href: '/my/personal-trainer-kuala-lumpur', title: 'Read in English: Personal Trainer in Kuala Lumpur' },
    ],
    cta: {
        title: 'Mulakan dengan jurulatih yang sesuai',
        body: 'Isi permintaan dalam dua minit - kami padankan anda dengan jurulatih bertauliah dalam 48 jam.',
        href: '/my/personal-trainer-kuala-lumpur',
        label: 'Lihat pakej latihan',
        bookSummary: 'jurulatih peribadi di KL',
        bookLabel: 'Cari jurulatih',
    },
}

content.summary.items = (c) => [
    `14 sesi: ${c.money(c.pt('Signature', 14), 0)} satu sesi`,
    `30 sesi: ${c.money(c.pt('Signature', 30), 0)} satu sesi (paling popular)`,
    `50 sesi: ${c.money(c.pt('Signature', 50), 0)} satu sesi`,
]

export default content
